<div *ngIf="permissionAccess" class="p-4">

    <div class="d-flex flex-column flex-md-row justify-content-between align-items-md-end mb-4 border-bottom pb-4">
        <div class="mb-3 mb-md-0">
            <h2 class="fw-semibold text-dark mb-1">Ejecutar Query a DB</h2>
            <p class="text-secondary mb-0">Ejecucion de sentencias SQL (INSERT O UPDATE)</p>
        </div>
    </div>

    <ng-template #contenido let-modal let-c="close">
        <div>
            <div class="modal-header">
                <h4 class="modal-title">Factor Authentication MR Presta</h4>
                <button class="close" type="button" id="closeModal" (click)="c('')">x</button>
            </div>
            <div class="modal-body">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Seleccione el email del usuario</mat-label>
                    <mat-select [(ngModel)]="emailSelected">
                        <mat-option [value]="email" *ngFor="let email of emailsApproved">
                            {{email}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-50">
                    <mat-label>Ingresa el codigo para ejecutar query: </mat-label>
                    <input matInput type="text" name="code" [(ngModel)]="code" (keyup.enter)="getCode(code)">
                </mat-form-field>
                <!-- <label for="code">Ingresa el codigo para ejecutar query: </label> -->
            </div>
            <button class="btn btn-primary m-2" (click)="getCode(code)">Enviar</button>
        </div>
    </ng-template>

    <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 pt-5">
            <div class="form-group">
                <div style="display: flex; gap: 5px; align-items: center;">
                    <label class="form-control-label"><b>Ingrese sentencia SQL (INSERT O UPDATE)</b></label>
                </div>
                <div class="set-query">
                    <mat-icon style="position:relative;top:2px;">code</mat-icon>
                    <textarea class="form-control" id="consulta" [formControl]="formQuery">
                    </textarea>
                </div>
            </div>
        </div>
    </div>
    <div class="row d-flex justify-content-start">
        <div class="form-group col-sm-6 col-md-2 col-lg-2 col-xl-2 pt-3">
            <button type="button" class="btn btn-primary" (click)="executeQuery(formQuery, contenido)">Ejecutar
                query</button>
        </div>
    </div>
</div>
<app-restricted-module-view *ngIf="!permissionAccess"></app-restricted-module-view>